import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {startCall, closeFlow} from './TvActivationCodeRecoveryBlockSlice';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';

const EmptyListMessage = (props) => {
  let callRef = 'tel:' + Config.technicalSupportPhone;
  let cssMobile = isMobile ? ' ismobile' : '';
  return (
    <div className='error-message-view'>
      <div>
        <div className={'caption' + cssMobile}>
          <div>רק רגע, אנחנו לא מזהים שיש לך שירות {window.Config.brand_Name_HE} TV</div>
        </div>
      </div>

      <div className={'caption-2' + cssMobile}>
        <div>נציגי השירות שלנו ישמחו לעזור</div>
      </div>
      {isMobile ? (
        <div className='call-button-wrapper'>
          <a href={callRef} className='call-btn'>
            <div className='phone'></div>
            <span> לשיחה עם נציג </span>
          </a>
        </div>
      ) : (
        <div className='call-button-wrapper'>
          <div className='call-btn-text'>
            <div className='phone'></div>
            <span> אנחנו זמינים במספר </span>
            <span>{window.Config.technicalSupportPhone}</span>
          </div>
        </div>
      )}
      <div className='close-button-wrapper'>
        <button className='close-btn' onClick={() => props.closeFlow()}>
          סיום
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {isSuccsess: state.TvActivationCodeRecovery.isSuccsess};
};

const mapDispatchToProps = {
  startCall,
  closeFlow,
};

export default connect(null, mapDispatchToProps)(EmptyListMessage);
